interface loaderTextOptions {
  'pl-PL': string,
  'en-US': string,
  'uk-UA': string,
}

const loaderText: loaderTextOptions = {
  'pl-PL': 'Trwa wczytywanie...',
  'en-US': 'Loading...',
  'uk-UA': 'Триває збереження...',
};

const bannerText: loaderTextOptions = {
  'pl-PL': 'e\u2060-\u2060Urząd\u00A0Skarbowy',
  'en-US': 'e\u2060-\u2060Tax\u00A0Office',
  'uk-UA': 'eлектронна податкова служба',
};

const loaderTextLanguageFallback = 'pl-PL';

export const getQueryVariable = (variableName: string): string | undefined => {
  const query = window.location.search.substring(1);
  const variables = query.split('&');
  for (const variable of variables) {
    const pair = variable.split('=');
    if (decodeURIComponent(pair[0]) === variableName) {
      return decodeURIComponent(pair[1]);
    }
  }
  console.log('Query variable %s not found', variableName);
};

export const parseJwt = (token: string) => {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));

  return JSON.parse(jsonPayload);
};

export const showLoaderText = (slng: string | undefined): void => {
  const lang = slng || loaderTextLanguageFallback;
  document.getElementById('appLoaderText')!.innerText = loaderText[lang as keyof loaderTextOptions];
};

export const showBannerText = (slng: string | undefined): void => {
  const lang = slng || loaderTextLanguageFallback;
  document.getElementById('appLoaderBannerText')!.innerText = bannerText[lang as keyof loaderTextOptions];
};
